import {Route, Switch} from "react-router-dom";
import Home from "../../home/Home.jsx";
import Login from "../../auth/Login.jsx";
import Register from "../../auth/Register.jsx";
import Dashboard from "../../dashboard/Dashboard.jsx";
import Profile from "../../dashboard/Profile.jsx";
import ChangePassword from "../../dashboard/ChangePassword.jsx";
import ActiveAppointments from "../../dashboard/ActiveAppointments.jsx";
import PastAppointments from "../../dashboard/PastAppointments.jsx";

export default function Navigation() {
    return (<Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/auth/login" component={Login}/>
        <Route exact path="/auth/register" component={Register}/>
        <Route exact path="/user/dashboard" component={Dashboard}/>
        <Route exact path="/user/profile" component={Profile}/>
        <Route exact path="/user/change-password" component={ChangePassword}/>
        <Route exact path="/user/active-appointments" component={ActiveAppointments}/>
        <Route exact path="/user/past-appointments" component={PastAppointments}/>
    </Switch>)
}

